import { useState } from 'react';
import { useTheme } from '../../hooks/useTheme';

export default function FilterPill({ filter, onRemove }) {
  const { currentThemeType, themeTypes } = useTheme();
  const [isHovered, setIsHovered] = useState(false);

  const isLightTheme = currentThemeType === themeTypes.LIGHT;

  const getFilterLabel = () => {
    switch (filter.type) {
      case 'linked-to':
        return `Linked: ${filter.itemTitle}`;
      case 'unlinked-to':
        return `Unlinked: ${filter.itemTitle}`;
      case 'exclude-collection':
        return `Exclude: ${filter.collectionTitle}`;
      case 'ai-response-collection':
        return filter.collectionTitle;
      default:
        return filter.label;
    }
  };

  return (
    <div
      className={`relative rounded-lg px-3 py-1.5 text-sm flex items-center justify-between transition-all duration-200 ${
        isLightTheme
          ? 'bg-rose-100 border border-rose-300 text-rose-800 hover:bg-rose-200'
          : 'bg-purple-600/20 border border-purple-500/30 text-purple-300 hover:bg-purple-600/30'
      }`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <span className="truncate pr-2">{getFilterLabel()}</span>
      {isHovered && (
        <button
          onClick={() => onRemove(filter.id)}
          className={`flex-shrink-0 w-4 h-4 rounded-full flex items-center justify-center transition-colors duration-150 ${
            isLightTheme
              ? 'bg-rose-500 hover:bg-rose-600'
              : 'bg-purple-500 hover:bg-purple-600'
          }`}
        >
          <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      )}
    </div>
  );
}
